// dateFilterStore.ts
import { create } from "zustand";
import { agentIds, apps, dateOptions, emailFilter } from "../common/Constants";
import { CommonStore } from "./CommonStoreType";

const defaultAgent = {
  label: "Job Description Creation",
  value: agentIds["Job Description Creation"],
};

const useCommonStore = create<CommonStore>((set) => ({
  selectedValue: dateOptions[3],
  setSelectedValue: (value) => set({ selectedValue: value }),

  customRange: { from: null, to: null },
  setCustomRange: (range) => set({ customRange: range }),
  userLogPage: 1,
  setUserLogPage: (page: number) =>
    set((state) => ({ ...state, userLogPage: page })),

  userLogPageSize: 1,
  setUserLogPageSize: (size: number) =>
    set((state) => ({ ...state, userLogPageSize: size })),
  activeStatsButton: "new-users",
  setActiveStatsButton: (id) => set(() => ({ activeStatsButton: id })),

  timeFilter: { label: "Last 24 hours", value: "last_24_hours" },

  setTimeFilter: (filter) => set({ timeFilter: filter }),

  pageIndex: 0,
  setPageIndex: (page) => set({ pageIndex: page }),
  pageSize: 10,
  setPageSize: (size) => set((state) => ({ ...state, pageSize: size })),

  selectedAgent: defaultAgent,
  setSelectedAgent: (value) => set({ selectedAgent: value }),
  selectedFeedback: apps[0],
  setSelectedFeedback: (value) => set({ selectedFeedback: value }),
  streaming: false,
  setStreaming: (value) => set({ streaming: value }),
  thinkTime: null,
  setThinkTime: (value) => set({ thinkTime: value }),
  chatData: null,
  setChatData: (updater) =>
    set((state) => ({
      chatData:
        typeof updater === "function" ? updater(state.chatData) : updater,
    })),
  isAnalyzing: false,
  setIsAnalyzing: (value) => set({ isAnalyzing: value }),
  selectedUser: "",
  setSelectedUser: (value) => set({ selectedUser: value }),
  activeResTab: "result",
  setActiveResTab: (tab) => set({ activeResTab: tab }),
  mailStatusFilter: emailFilter[0],
  setMailStatusFilter: (value) => set({ mailStatusFilter: value }),
}));

export default useCommonStore;
